import { render, staticRenderFns } from "./AccionDescargarAmbosPdf.vue?vue&type=template&id=59a16984&scoped=true&"
import script from "./AccionDescargarAmbosPdf.vue?vue&type=script&lang=js&"
export * from "./AccionDescargarAmbosPdf.vue?vue&type=script&lang=js&"
import style0 from "./AccionDescargarAmbosPdf.vue?vue&type=style&index=0&id=59a16984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a16984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a16984')) {
      api.createRecord('59a16984', component.options)
    } else {
      api.reload('59a16984', component.options)
    }
    module.hot.accept("./AccionDescargarAmbosPdf.vue?vue&type=template&id=59a16984&scoped=true&", function () {
      api.rerender('59a16984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionDescargarAmbosPdf.vue"
export default component.exports